export default (expireIn) => {
  // take expireIn from accessToken,
  // convert it to ms, and
  // remove 5 minutes to allow for reftech before it expires
  return expireIn * 1000 - 1000 * 60 * 5
}
